import { usePermission } from '@circlefin/permissions/react'
import { CIRCLE_WALLET_TRANSFER_TYPE_SELECTION } from '@services/permissions'

import { useWalletApprovalPolicy } from '../../../../hooks/approval-policy'

export const useTransferTypeValidate = () => {
  const [{ touched, settings }] = useWalletApprovalPolicy()
  const [, { isAuthorized }] = usePermission(
    CIRCLE_WALLET_TRANSFER_TYPE_SELECTION,
  )

  // Ignore transfer type step when not enabled
  const isTouched = touched?.transferType || !isAuthorized
  const isValid = settings?.applyToApi != null || !isAuthorized
  const isEmpty = settings?.applyToApi == null || !isAuthorized

  return {
    isTouched,
    isValid,
    isEmpty,
    enableSaveExit: isValid,
  }
}
